function isMobileDevice(): boolean {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
}

export function isMobile(): boolean {
  return isMobileDevice() || window.matchMedia('(max-width: 500px)').matches;
}
